import React, { useRef, useState } from "react";
import Papa from "papaparse";
import { getTimeEntries, createTimeEntry } from "../../api";

export default function CsvTools({ createdById, clients, timeCodes, rangeStart, rangeEnd }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const resolveClient = (val) => {
    if (!val) return null;
    if (/^\d+$/.test(String(val).trim())) return Number(val);
    const match = clients.find(
      (c) => c.name.toLowerCase() === String(val).trim().toLowerCase()
    );
    return match ? match.id : null;
  };

  const onExport = async () => {
    setBusy(true);
    try {
      const rows = await getTimeEntries({
        created_by: createdById, start_date: rangeStart, end_date: rangeEnd,
      });
      const nameById = Object.fromEntries(clients.map((c) => [String(c.id), c.name]));
      const csv = Papa.unparse(
        rows.map((e) => ({
          date: e.date,
          client: nameById[String(e.client)] || "",
          time_code: e.time_code,
          billable_code: e.billable_code,
          hours: e.hours,
          notes: e.notes,
          status: e.status,
        }))
      );
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `time_${rangeStart}_${rangeEnd}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setBusy(false);
    }
  };

  const onImport = (file) => {
    setBusy(true);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (result) => {
        const rows = result.data;
        let created = 0;
        for (const r of rows) {
          const lower = Object.fromEntries(
            Object.entries(r).map(([k, v]) => [k.toLowerCase().trim(), v])
          );
          if (!lower.date) continue;
          try {
            await createTimeEntry({
              date: lower.date,
              client: resolveClient(lower.client),
              time_code: lower.time_code || "",
              billable_code:
                (lower.billable_code || "BILLABLE").toUpperCase() === "NON_BILLABLE"
                  ? "NON_BILLABLE" : "BILLABLE",
              hours: lower.hours || "0",
              notes: lower.notes || "",
            });
            created += 1;
          } catch (e) {
            // skip bad rows; continue importing the rest
          }
        }
        setBusy(false);
        alert(`Imported ${created} draft entr${created === 1 ? "y" : "ies"}. Reload to see them.`);
      },
    });
  };

  return (
    <span style={{ display: "inline-flex", gap: 6 }}>
      <button disabled={busy} onClick={onExport}
        style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "4px 10px",
          background: "white", cursor: "pointer" }}>
        Export CSV
      </button>
      <button disabled={busy} onClick={() => fileRef.current?.click()}
        style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "4px 10px",
          background: "white", cursor: "pointer" }}>
        Import CSV
      </button>
      <input ref={fileRef} type="file" accept=".csv" style={{ display: "none" }}
        onChange={(e) => e.target.files[0] && onImport(e.target.files[0])} />
    </span>
  );
}
